import request from '@utils/request';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { Page } from 'shared-types';

export function useGetSpaDaysPage(propertyId: number, language: string) {
  return useQuery({
    queryKey: getSpaDaysPageKey(propertyId, language),
    queryFn: () => getSpaDaysPage(propertyId, language),
  });
}

export async function getSpaDaysPage(propertyId: number, language: string) {
  const { data } = await request.get(`${propertyId}/pages/spa-days/${language}`, {
    isPayloadCaseConverterDisabled: true,
  });
  return data as Page;
}

export const getSpaDaysPageKey = (propertyId: number, language: string) => [
  'spaDaysPage',
  propertyId,
  language,
];

export const getSpaDaysPagePrefetch = (
  queryClient: QueryClient,
  propertyId: number,
  language: string
) =>
  queryClient.prefetchQuery(getSpaDaysPageKey(propertyId, language), () =>
    getSpaDaysPage(propertyId, language)
  );
